<template>
  <div class="km-module">
    <vue-tel-input
      v-model="innerTel"
      :valid-characters-only="true"
      :style-classes="[
        'form-control',
        isDirty && (isValid ? 'is-valid' : 'is-invalid')
      ]"
      name="tel"
      :only-countries="countryList"
      :dropdown-options="
        countryList.length === 1 && countryList.includes(defaultCountry)
          ? {
              disabled: true,
              showFlags: true
            }
          : undefined
      "
      :input-options="{ placeholder }"
      :default-country="defaultCountry"
      @country-changed="countryChanged"
      @validate="validate"
      @focus="isFocus = true"
      @input="input"
    >
    </vue-tel-input>
  </div>
</template>

<script>
import { computed, defineComponent, ref } from '@nuxtjs/composition-api'

export default defineComponent({
  model: {
    prop: 'tel',
    event: 'change'
  },
  props: {
    tel: {
      type: Object,
      default: null
    },
    placeholder: {
      type: String,
      default: null
    },
    countryList: {
      type: Array,
      default: () => []
    }
  },
  setup(props, context) {
    const innerTel = ref(null)
    const isDirty = ref(false)
    const isFocus = ref(false)
    const isValid = ref(false)

    const defaultCountry = computed(() => process.env.DEFAULT_COUNTRY)

    function input(input, telInfo) {
      if (isFocus.value && input) {
        isDirty.value = true
      }
      context.emit('change', telInfo)
    }
    function validate(validInfo) {
      isValid.value = !!validInfo?.valid

      context.emit('validate', isValid.value)
    }
    function countryChanged(country) {
      context.emit('countryChanged', country?.iso2)
    }

    return {
      innerTel,

      isDirty,
      isFocus,
      isValid,

      defaultCountry,

      countryChanged,
      validate,
      input
    }
  }
})
</script>
